<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <h1>New Application</h1>

        <div>
          <b-form>
            <div class="card">
              <div class="card-header">Application Type Information</div>
              <div class="card-body">
                <b-row>
              <b-col cols="4">
                <BaseSelector v-model="programId"
                              :v="$v.programId"
                              label="Program"
                              slug="program"
                              :options=programOptions
                              setId="programId"
                              textField="name"
                              valueField="id"
                />
              </b-col>
              <b-col cols="4" v-if="applicationTypeOptions.length > 0">
                <BaseSelector v-model="applicationTypeId"
                              :v="$v.applicationTypeId"
                              label="Application Type"
                              slug="applicationTypeId"
                              :options=applicationTypeOptions
                              setId="applicationTypeId"
                              textField="name"
                              valueField="id"
                />
              </b-col>
              <b-col cols="4" v-if="subTypeOptions.length > 0 && programId != 'aca3b6f5-aee2-40f6-b096-a4dd529b4fab'">
                <BaseSelector v-model="subTypeId"
                              :v="$v.subTypeId"
                              label="Application Sub-Type"
                              slug="subTypeId"
                              :options=subTypeOptions
                              setId="subTypeId"
                              textField="name"
                              valueField="id"
                />
              </b-col>
                </b-row>
              </div>
            </div>
            <b-row class="float-right">
              <b-col>
                <b-button type="button" variant="secondary" to="/dashboard" role="button" class="mr-1">Cancel</b-button>
                <b-button type="button" variant="primary" @click="createApplication">Begin Application Upload</b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { required } from 'vuelidate/lib/validators'
  import router from "@/router";
  import ConfigService from "@/services/ConfigService";

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
  data: () => ({
    applicationTypeOptions: [],
    applicationTypeId: null,
    subTypeOptions: [],
    subTypeId: null,
    programOptions: [],
    programId: null,
  }),

  created() {
    document.title = "New Application - Facility and Provider Licensing System"
    this.loadPrograms()
  },

  methods: {
    loadPrograms() {
      axios.get(ConfigService.getApiUrl() + `/api/programs`)
        .then(response => {
          //Removing "Transfer Care Specialist" from program options
          this.programOptions = response.data.filter(obj => obj.name !== "Transfer Care Specialist");
        })
    },
    loadApplicationTypes() {
      const payload = {
        programId: this.programId,
        enabledOnly: true
      }
      axios.get(ConfigService.getApiUrl() + `/api/application-types`, {params: payload})
        .then(response => {
          this.applicationTypeOptions = response.data
          console.log(this.applicationTypeOptions)
        })
    },
    loadSubTypes() {
      const payload = {
        enabledOnly: true
      }
      axios.get(ConfigService.getApiUrl() + `/api/application-types/`+this.applicationTypeId+'/sub-types', {params: this.payload})
        .then(response => {
          this.subTypeOptions = response.data
        })
    },
    createApplication() {
      //ALF Relocation Program = 'N/A Sub-Type'
      //TODO: use code instead of id?
      if (this.programId == 'aca3b6f5-aee2-40f6-b096-a4dd529b4fab') {
        this.subTypeId = '9302de16-10da-4166-9536-8b874ddbb364'
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          document.getElementById('form-container').scrollIntoView()
        })
        return
      }
      const payload = {
        applicationTypeId: this.applicationTypeId,
        applicationSubTypeId: this.subTypeId,
      }
      axios.post(ConfigService.getApiUrl() + `/api/applications`, payload)
        .then(response => {
          router.push("/submitter/" + response.data)
      })
    },
  },
  watch: {
    programId(val) {
      this.loadApplicationTypes();
      this.applicationTypeId = null;
      this.subTypeId = null;
    },
    applicationTypeId(val) {
      this.loadSubTypes();
      this.subTypeId = null;
    }
  },

  validations() {
    return {
      applicationTypeId: {
        required
      },
      subTypeId: {
        required
      },
      programId: {
        required
      },
    }
  },
}
</script>
